import { render, staticRenderFns } from "./monthly_product_area.vue?vue&type=template&id=fc8e3f22&scoped=true"
import script from "./monthly_product_area.vue?vue&type=script&lang=js"
export * from "./monthly_product_area.vue?vue&type=script&lang=js"
import style0 from "./monthly_product_area.vue?vue&type=style&index=0&id=fc8e3f22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc8e3f22",
  null
  
)

export default component.exports